import { CreateLazyLoadingRule, UpdateLazyLoadingRule } from '@pubstack/common/src/adm/rules'
import { useNavigate, useParams } from 'react-router-dom'
import { useCreateLazyLoadingRule, useLazyLoadingRule, useLazyLoadingRules, useUpdateLazyLoadingRule } from '~/api/adm/lazy-loading-rules.api'
import { useToast } from '~/components/Toast/useToasts'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmLazyLoadingEditPage } from './PureAdmLazyLoadingEditPage'

export const AdmLazyLoadingEditPage: React.FunctionComponent = () => {
  const navigate = useNavigate()
  const toast = useToast()
  const breadcrumbs = useBreadcrumbs()
  const { lazyLoadingRuleId = '' } = useParams()

  const { data: lazyLoadingRule, isFetching, isError } = useLazyLoadingRule(lazyLoadingRuleId)
  const { data: lazyLoadingRules } = useLazyLoadingRules()

  const { mutateAsync: createLazyLoadingRule } = useCreateLazyLoadingRule({ errorToast: 'An error occurred while saving this rule.' })
  const { mutateAsync: updateLazyLoadingRule } = useUpdateLazyLoadingRule({ errorToast: 'An error occurred while saving this rule.' })

  // The mutations already toast the error through `errorToast`, so swallow the rejection to avoid an unhandled one
  const onCreateLazyLoadingRule = async (lazyLoadingRule: CreateLazyLoadingRule) => {
    try {
      const newRule = await createLazyLoadingRule(lazyLoadingRule)
      toast.success(`${newRule.name} added to your inventory.`)
      navigate('/monetization/one/lazy-loading')
    } catch (_e) {
      // already toasted
    }
  }

  const onUpdateLazyLoadingRule = async (lazyLoadingRule: UpdateLazyLoadingRule, stacksUse: boolean) => {
    try {
      await updateLazyLoadingRule(lazyLoadingRule)
      toast.admSuccess(lazyLoadingRule.name, stacksUse, navigate)
      navigate('/monetization/one/lazy-loading')
    } catch (_e) {
      // already toasted
    }
  }

  return (
    <PureAdmLazyLoadingEditPage
      isEditing={!!lazyLoadingRuleId}
      isLoading={isFetching}
      isError={isError}
      lazyLoadingRule={lazyLoadingRule}
      existingLazyLoadingRules={lazyLoadingRules}
      breadcrumbs={breadcrumbs}
      onCreateLazyLoadingRule={onCreateLazyLoadingRule}
      onUpdateLazyLoadingRule={onUpdateLazyLoadingRule}
      onBack={() => navigate(-1)}
    />
  )
}
